import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { MatDialogClose } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { GxInputDirective } from '../../../directives/gxinput.directive';
import { MatInput } from '@angular/material/input';
import { MatFormField } from '@angular/material/form-field';
import { CATEGORIES, UserFeedbackService } from './user-feedback.service';
import { MatIcon } from '@angular/material/icon';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-feedback-popup',
  templateUrl: './feedback-popup.component.html',
  styleUrls: ['./_radioStyles.scss', './feedback-popup.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    GxInputDirective,
    MatButton,
    MatDialogClose,
    MatTooltip,
    TranslateModule,
    MatIcon,
    MatOption,
    MatSelect,
  ],
  providers: [UserFeedbackService],
})
export class FeedbackPopupComponent {
  public readonly categories = CATEGORIES;

  constructor(public userFeedback: UserFeedbackService) {
  }
}
